export default {
  computed: {},
  data() {
    return {};
  },
  methods: {
    tranferOrder(transferCode) {
      // 0 - из объекта, 1 - в объект, 2 - нет нужных типов
      let arr = ["Г", "Ж", "Э"];
      let w = transferCode.split("-")[1];
      if (w && w.length == 2) {
        for (let i = 0; i < arr.length; i++) {
          if (w[0] == arr[i]) {
            return 0;
          }
          if (w[1] == arr[i]) {
            return 1;
          }
        }
      }

      return 2;
    },
    tranferOrderByObject(transferCode, objectCode) {
      // 0 - из объекта, 1 - в объект, 2 - нет нужных типов
      let w = transferCode.split("-")[1];
      if (w && w.length == 2) {
        if (w[0] == objectCode) {
          return 0;
        } else if (w[1] == objectCode) {
          return 1;
        } else {
          return 2;
        }
      }
      return 2;
    }
  }
};
